import {
  updateLabelConfig,
  labelConfigSelector,
  referenceNumberErrorMessageSelector,
  isLabelPropertyEnabledSelector,
  onLabelPropertyValueChange,
} from '../../../data/labelInfos/index.js'
import {getState, useSelector} from '../../../store.js'
import {
  PRESET_TEMPLATES,
  PRESET_TEMPLATE__ORDER_NUMBER,
  PRESET_TEMPLATE__PRODUCT_NAMES,
  PRESET_TEMPLATE__PRODUCT_SKUS,
  PRESET_TEMPLATE__REFERENCE_ID,
} from '../../../common/constants/LabelConfig.js'
import renderTemplate from '../../../common/renderTemplate.js'
import ConfigSelect from './ConfigSelect.js'
import {presetTemplateStateSelector} from '../../../data/presets.js'
import TextInput from '../../../common/components/TextInput.js'
import {
  AMAZON_SHIPPER,
  AUSTRALIA_POST,
  CANADA_POST,
  DHL_ECOMMERCE,
  DHL,
  ENDICIA,
  FEDEX,
  NEWGISTICS,
  PITNEY_CBDS,
  PITNEY,
  PITNEY_MERCHANT,
  PITNEY_PRESORT,
  SENDLE,
  UPS,
  USPS_SHIP,
  FEDEX_360,
  SHIPPO,
} from '../../../common/constants/ShipperNames.js'
import ConfigTextInput from './ConfigTextInput.js'
import {
  ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
  formatMetaClassName,
} from './useLabelProperty.js'
import className from '../../../common/className.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'

export const LABEL_PROPERTY_REFERENCE_NUMBER = 'reference_number'
export const LABEL_PROPERTY_REFERENCE_NUMBER__STR__TEMPLATE_REF =
  'reference_number__str__template_ref'
export const VALID_REFERENCE_NUMBER_SHIPPER_TYPES = [
  AMAZON_SHIPPER,
  AUSTRALIA_POST,
  CANADA_POST,
  DHL_ECOMMERCE,
  DHL,
  ENDICIA,
  FEDEX,
  FEDEX_360,
  NEWGISTICS,
  PITNEY_CBDS,
  PITNEY,
  PITNEY_MERCHANT,
  PITNEY_PRESORT,
  SENDLE,
  SHIPPO,
  UPS,
  USPS_SHIP,
]
export const VALID_REFERENCE_NUMBER_LABEL_PROPERTIES = [
  LABEL_PROPERTY_REFERENCE_NUMBER,
  LABEL_PROPERTY_REFERENCE_NUMBER__STR__TEMPLATE_REF,
]

export function referenceNumberLabelPropertiesFunc(shipperType, labelInfoID) {
  const labelConfig = labelConfigSelector(getState(), {labelInfoID})

  const properties = [LABEL_PROPERTY_REFERENCE_NUMBER]

  if (labelConfig[LABEL_PROPERTY_REFERENCE_NUMBER__STR__TEMPLATE_REF]) {
    properties.push(LABEL_PROPERTY_REFERENCE_NUMBER__STR__TEMPLATE_REF)
  }

  return properties
}

function ReferenceNumberTemplates() {
  const {labelInfoID, shipperType, isSummary, isPickMode} =
    useLabelConfigContext()
  const propertySpecs = ReferenceNumber.propertySpecList[0]
  const presetTemplateState = useSelector(presetTemplateStateSelector)
  const config = useSelector((state) =>
    labelConfigSelector(state, {labelInfoID}),
  )
  const isReferenceNumberPropertyEnabled = useSelector((state) =>
    isLabelPropertyEnabledSelector(state, {
      labelInfoID,
      labelProperty: LABEL_PROPERTY_REFERENCE_NUMBER,
    }),
  )

  const reference_number = config[LABEL_PROPERTY_REFERENCE_NUMBER] || ''
  const reference_number__str__template_ref =
    config[LABEL_PROPERTY_REFERENCE_NUMBER__STR__TEMPLATE_REF] || ''

  const showSubInput =
    propertySpecs.validShipperTypes.includes(shipperType) &&
    isReferenceNumberPropertyEnabled &&
    !isSummary &&
    !isPickMode

  return (
    <>
      <ConfigSelect
        className="margin-bottom-5"
        label="Reference Number"
        value={reference_number__str__template_ref}
        onChange={(value) => {
          updateLabelConfig(labelInfoID, {
            [LABEL_PROPERTY_REFERENCE_NUMBER__STR__TEMPLATE_REF]: value,
          })

          onLabelPropertyValueChange(
            labelInfoID,
            LABEL_PROPERTY_REFERENCE_NUMBER,
          )
        }}
        noEmptyOption
        labelProperty={LABEL_PROPERTY_REFERENCE_NUMBER}
        propertySpecs={propertySpecs}
      >
        <option value={PRESET_TEMPLATE__ORDER_NUMBER}>Order ID</option>
        <option value={PRESET_TEMPLATE__REFERENCE_ID}>RMA ID</option>
        <option value={PRESET_TEMPLATE__PRODUCT_NAMES}>Product Names</option>
        <option value={PRESET_TEMPLATE__PRODUCT_SKUS}>Product SKUs</option>
        <option value="">Static Value</option>
      </ConfigSelect>
      {showSubInput && (
        <li
          className={className`list__item--shipping-options has-sub-value btm-offset-7 ${formatMetaClassName(
            LABEL_PROPERTY_REFERENCE_NUMBER,
          )}`}
        >
          {reference_number__str__template_ref ? (
            <div>
              example:{' '}
              {renderTemplate(
                PRESET_TEMPLATES[reference_number__str__template_ref],
                presetTemplateState,
              )}
            </div>
          ) : (
            <div className="w-50">
              <TextInput
                placeholder="Enter a value..."
                onChange={(value) =>
                  updateLabelConfig(labelInfoID, {
                    [LABEL_PROPERTY_REFERENCE_NUMBER]: value,
                  })
                }
                value={reference_number}
              />
            </div>
          )}
        </li>
      )}
    </>
  )
}

export default function ReferenceNumber() {
  const {labelInfoID, shipperType, onChange, isLabelEnableMode} =
    useLabelConfigContext()
  const propertySpecs = ReferenceNumber.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )
  const error = useSelector((state) =>
    referenceNumberErrorMessageSelector(state, {labelInfoID, shipperType}),
  )

  if (isLabelEnableMode) {
    return <ReferenceNumberTemplates />
  }

  return (
    <ConfigTextInput
      label="Reference Number"
      onChange={(value) => {
        updateLabelConfig(labelInfoID, {
          [labelProperty]: value,
        })

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
      errorMessage={error}
    />
  )
}

ReferenceNumber.propertySpecList = [
  {
    validShipperTypes: VALID_REFERENCE_NUMBER_SHIPPER_TYPES,
    labelPropertiesFunc: referenceNumberLabelPropertiesFunc,
    dependentPropertiesFunc: ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: () => VALID_REFERENCE_NUMBER_LABEL_PROPERTIES,
  },
]
